function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.313 26.757h23.444V3.312H3.312v23.445z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 29.5c8.008 0 14.5-6.492 14.5-14.5S23.008.5 15 .5.5 6.992.5 15 6.992 29.5 15 29.5zM15.035 2.813v24.444m12.222-12.222H2.812m22.723 10.5l-21-21m0 21l21-21"
}));

var SvgPlaceholderWhite = function SvgPlaceholderWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgPlaceholderWhite;